/**
 * @author Iskra Popova
 *
 * PercentScalableSceneView class.
 * Builds a SceneView that mutates positions on view size change.
 */

import { ViewOrientation } from "./BaseView";
import { IViewConfigSchema, IObjectConfig, ILayersList } from "../../src/baseConfigs/layoutConfigShema";
import App from "../App";
import Layout from "../utils/Layout";
import SceneView from "./SceneView";
import BitmapTextField from "./components/BitmapTextField";
import ISceneOptions from '../contracts/ISceneOptions';
import SceneViewContainer from './SceneViewContainer';
import { Container } from "pixi.js";

export default class PercentScalableSceneView extends SceneView {

    protected mergeConfigMain: ILayersList;
    protected mergeConfigSecondary: ILayersList;

    constructor(sceneConfig: IViewConfigSchema, portraitConfig: IViewConfigSchema, options?: ISceneOptions) {
        super(sceneConfig, portraitConfig, options);
        this.setupMergeConfigs();
        this.reposition();
    }

    setupMergeConfigs() {
        const portraitConfig = this.sceneConfigPortrait;
        const defaultConfig = this.sceneConfig;
        let mergeConfigSecondary: ILayersList = {};
        let mergeConfigMain: ILayersList = {};
        if (this.groups && portraitConfig && portraitConfig.groups) {
            for (const groupId in portraitConfig.groups) {
                mergeConfigSecondary[groupId] = portraitConfig.groups[groupId];
            }
            if (defaultConfig.groups) {
                for (const groupId in defaultConfig.groups) {
                    if (!portraitConfig.groups[groupId]) {
                        mergeConfigSecondary[groupId] = defaultConfig.groups[groupId];
                    }
                }
            }

        } else if (defaultConfig.groups) {
            mergeConfigSecondary = defaultConfig.groups;
        }

        if (defaultConfig.groups) {
            mergeConfigMain = defaultConfig.groups;
        }

        this.mergeConfigMain = mergeConfigMain;
        this.mergeConfigSecondary = mergeConfigSecondary;
    }

    public reposition() {
        // this.pauseParticles();
        // const canvasWidth = Layout.canvasWidth;
        // const canvasHeight = Layout.canvasHeight;
        const config = this.currentSceneConfig;
        const defaultConfig = this.sceneConfig;
        let mergeConfig: ILayersList = config === defaultConfig ? this.mergeConfigMain : this.mergeConfigSecondary;
        // if (this.groups && config.groups) {
        //     for (const groupId in config.groups) {
        //         mergeConfig[groupId] = config.groups[groupId];
        //     }
        //     if (defaultConfig.groups) {
        //         for (const groupId in defaultConfig.groups) {
        //             if (!config.groups[groupId]) {
        //                 mergeConfig[groupId] = defaultConfig.groups[groupId];
        //             }
        //         }
        //     }

        // } else if (defaultConfig.groups) {
        //     mergeConfig = defaultConfig.groups;
        // }

        if (this.groups && mergeConfig) {
            for (const groupId in mergeConfig) {
                const props = mergeConfig[groupId].id.split("~");
                //console.log("YYY ", props);
                const id = props.shift();
                if (this.groups.has(groupId)) {
                    const group = this.groups.get(groupId);
                    const bounds = this.parseScaledBoundConfig(mergeConfig[groupId]);
                    group.pivot.x = group.pivot.y = 0;
                    group.x = Layout.scalePixels(bounds.x);
                    group.y = Layout.scalePixels(bounds.y);
                    group.scale.x = group.scale.y = 1;
                    
                    group.children.forEach(ch => {
                        if (ch instanceof SceneViewContainer) {
                            ch.changeOrientationMasksParse(bounds, mergeConfig[groupId].positions)
                        }
                    })
                   //console.log(groupId, props, "JJJ ", group, bounds);

                    const container = group as Container;

                    if (props && props.length) {

                        //console.log("YYY---111 ", props);

                        props.forEach(prop => {
                            let newBound;
                            const fullBound = this.getFractionBound(100, 100);
                            switch (prop) {
                                case "fit_uni":
                                    Layout.testSetWidth(group, bounds.width);
                                    if (group.height < Layout.scalePixels(bounds.height)) {
                                        Layout.testSetHeight(group, bounds.height);
                                    }
                                    break;
                                case "h_scale_uni_limit":
                                    Layout.testSetWidth(group, bounds.width);
                                    if (group.height > Layout.scalePixels(bounds.height)) {
                                        Layout.testSetHeight(group, bounds.height);
                                    }
                                    break;
                                case "h_scale_uni":
                                    Layout.testSetWidth(group, bounds.width);
                                    break;
                                case "v_scale_uni_limit":
                                    Layout.testSetHeight(group, bounds.height);
                                    if (group.width > Layout.scalePixels(bounds.width)) {
                                        Layout.testSetWidth(group, bounds.width);
                                    }
                                    break;
                                case "v_scale_uni":
                                    Layout.testSetHeight(group, bounds.height);
                                    break;
                                case "fit":
                                    Layout.testSetWidth(group, bounds.width, false);
                                    Layout.testSetHeight(group, bounds.height, false);
                                    break;
                                case "h_scale":
                                    Layout.testSetWidth(group, bounds.width, false);
                                    break;
                                case "v_scale":
                                    Layout.testSetHeight(group, bounds.height, false);
                                    break;
                                case "v_center":
                                    newBound = this.getFractionBound(0, 50)
                                    group.y = Layout.scalePixels(newBound.height) - container.height / 2;
                                    break;
                                case "v_center_out":
                                        newBound = this.getFractionBound(0, 50)
                                        group.y = Layout.scalePixels(newBound.height) - container.height / 2;
                                        if (Layout.scalePixels(fullBound.height) <= group.y + group.height || group.y <= 0) {
                                            group.visible = false;
                                            group.alpha = 0;
                                        } else {
                                            group.visible = true;
                                            group.alpha = 1;
                                        }
                                        break;
                                case "v_top_out":
                                    newBound = this.getFractionBound(0, 0)
                                    group.y = Layout.scalePixels(newBound.height) ;
                                    if (Layout.scalePixels(fullBound.height) < group.y + group.height ) {
                                        group.visible = false;
                                        group.alpha = 0;
                                    } else {
                                        group.visible = true;
                                        group.alpha = 1;
                                    }
                                    break;
                                case "v_top_limit":
                                case "v_top":
                                    newBound = this.getFractionBound(0, 0)
                                    group.y = Layout.scalePixels(newBound.height) ;
                                    break;
                                    case "v_bottom_limit":
                                        newBound = this.getFractionBound(0, 100)
                                        const newY = Layout.scalePixels(newBound.height) - container.height / container.scale.y ;
                                        group.y = newY > 0 ? newY : 0;
                                        break;
                                case "v_bottom_out":
                                    newBound = this.getFractionBound(0, 100)
                                    const newY1 = Layout.scalePixels(newBound.height) - container.height / container.scale.y ;
                                    if (newY1 < 0) {
                                        group.visible = false;
                                        group.alpha = 0;
                                    } else {
                                        group.visible = true;
                                        group.alpha = 1;
                                        group.y = newY1;
                                    }
                                case "v_bottom":
                                    newBound = this.getFractionBound(0, 100)
                                    // group.y = Layout.scalePixels(newBound.height) - container.height / container.scale.y ; //TODO - check why it was written like that
                                    group.y = Layout.scalePixels(newBound.height) - container.height  ;
                                    break;
                                case "h_center":
                                    newBound = this.getFractionBound(50, 0)
                                    group.x = Layout.scalePixels(newBound.width) - container.width / 2;
                                    break;
                                case "h_center_out":
                                    newBound = this.getFractionBound(0, 50)
                                    group.x = Layout.scalePixels(newBound.width) - container.width / 2;
                                    if (Layout.scalePixels(fullBound.width) <= group.x + group.width || group.x <= 0) {
                                        group.visible = false;
                                        group.alpha = 0;
                                    } else {
                                        group.visible = true;
                                        group.alpha = 1;
                                    }
                                    break;

                                case "h_left_out":
                                    newBound = this.getFractionBound(0, 0)
                                    group.x = Layout.scalePixels(newBound.width) ;
                                    if (Layout.scalePixels(fullBound.width) < group.x + group.width ) {
                                        group.visible = false;
                                        group.alpha = 0;
                                    } else {
                                        group.visible = true;
                                        group.alpha = 1;
                                    }
                                    break;
                                case "h_left_limit":
                                case "h_left":
                                    newBound = this.getFractionBound(0, 0)
                                    group.x = Layout.scalePixels(newBound.width) ;
                                    break;
                                case "h_right":
                                    newBound = this.getFractionBound(100, 0)
                                    group.x = Layout.scalePixels(newBound.width) - container.width  ;
                                    break;
                                case "h_right_limit":
                                    newBound = this.getFractionBound(100, 0)
                                    const newX = Layout.scalePixels(newBound.width) - container.width   ;
                                    group.x = newX > 0 ? newX : 0;
                                    break;
                                case "h_right_out":
                                    newBound = this.getFractionBound(0, 100)
                                    const newX1 = Layout.scalePixels(newBound.width) - container.width ;
                                    if (newX1 < 0) {
                                        group.visible = false;
                                        group.alpha = 0;
                                    } else {
                                        group.visible = true;
                                        group.alpha = 1;
                                        group.x = newX1;
                                    }
                                default:
                                    break;
                            }
                        })
                    }




                    if(mergeConfig[groupId].fitScale) {
                        const prop = mergeConfig[groupId].fitScale;
                        switch (prop) {
                            case "fit_uni":
                                Layout.testSetWidth(group, bounds.width);
                                if (group.height < Layout.scalePixels(bounds.height)) {
                                    Layout.testSetHeight(group, bounds.height);
                                }
                                break;
                            case "fit":
                                Layout.testSetWidth(group, bounds.width, false);
                                Layout.testSetHeight(group, bounds.height, false);
                            default:
                                break;
                        }
                    }

                    if(mergeConfig[groupId].verticalScale) {
                        const prop = mergeConfig[groupId].verticalScale;
                        switch (prop) {
                            case "scale_uni_limit":  // v_scale_uni_limit
                                Layout.testSetHeight(group, bounds.height);
                                if (group.width > Layout.scalePixels(bounds.width)) {
                                    Layout.testSetWidth(group, bounds.width);
                                }
                                break;
                            case "scale_uni":  // v_scale_uni
                                Layout.testSetHeight(group, bounds.height);
                                break;
                            case "scale":  // v_scale
                                Layout.testSetHeight(group, bounds.height, false);
                            default:
                                break;
                        }
                    }

                    if(mergeConfig[groupId].horizontalScale) {
                        const prop = mergeConfig[groupId].horizontalScale;
                        switch (prop) {
                            case "scale_uni_limit":  // h_scale_uni_limit
                                Layout.testSetWidth(group, bounds.width);
                                if (group.height > Layout.scalePixels(bounds.height)) {
                                    Layout.testSetHeight(group, bounds.height);
                                }
                                break;
                            case "scale_uni":  // h_scale_uni
                                Layout.testSetWidth(group, bounds.width);
                                break;
                            case "scale":  // h_scale
                                Layout.testSetWidth(group, bounds.width, false);
                                break;
                            default:
                                break;
                        }
                    }

                    if(mergeConfig[groupId].verticalAlign) {
                        const prop = mergeConfig[groupId].verticalAlign;
                        let newBound;
                        const fullBound = this.getFractionBound(100, 100);
                        switch (prop) {
                            case "center":  // v_center
                                newBound = this.getFractionBound(0, 50)
                                group.y = Layout.scalePixels(newBound.height) - container.height / 2;
                                break;
                            case "center_out":  // v_center_out
                                newBound = this.getFractionBound(0, 50)
                                group.y = Layout.scalePixels(newBound.height) - container.height / 2;
                                if (Layout.scalePixels(fullBound.height) <= group.y + group.height || group.y <= 0) {
                                    group.visible = false;
                                    group.alpha = 0;
                                } else {
                                    group.visible = true;
                                    group.alpha = 1;
                                }
                                break;
                            case "top_out":  // v_top_out
                                newBound = this.getFractionBound(0, 0)
                                group.y = Layout.scalePixels(newBound.height) ;
                                if (Layout.scalePixels(fullBound.height) < group.y + group.height ) {
                                    group.visible = false;
                                    group.alpha = 0;
                                } else {
                                    group.visible = true;
                                    group.alpha = 1;
                                }
                                break;
                            case "top_limit":  // v_top_limit
                            case "top":  // v_top
                                newBound = this.getFractionBound(0, 0)
                                group.y = Layout.scalePixels(newBound.height) ;
                                break;
                            case "bottom_limit":  // v_bottom_limit
                                newBound = this.getFractionBound(0, 100)
                                const newY = Layout.scalePixels(newBound.height) - container.height / container.scale.y ;
                                group.y = newY > 0 ? newY : 0;
                                break;
                            case "bottom_out":  // v_bottom_out
                                newBound = this.getFractionBound(0, 100)
                                const newY1 = Layout.scalePixels(newBound.height) - container.height / container.scale.y ;
                                if (newY1 < 0) {
                                    group.visible = false;
                                    group.alpha = 0;
                                } else {
                                    group.visible = true;
                                    group.alpha = 1;
                                    group.y = newY1;
                                }
                            case "bottom":  // v_bottom
                                newBound = this.getFractionBound(0, 100)
                                // group.y = Layout.scalePixels(newBound.height) - container.height / container.scale.y ; //TODO - check why it was written like that
                                group.y = Layout.scalePixels(newBound.height) - container.height  ;
                            default:
                                break;
                        }
                    }

                    if(mergeConfig[groupId].horizontalAlign) {
                        const prop = mergeConfig[groupId].horizontalAlign;
                        let newBound;
                        const fullBound = this.getFractionBound(100, 100);
                        switch (prop) {
                            case "center":  // h_center
                                    newBound = this.getFractionBound(50, 0)
                                    group.x = Layout.scalePixels(newBound.width) - container.width / 2;
                                    break;
                            case "center_out":  // h_center_out
                                newBound = this.getFractionBound(0, 50)
                                group.x = Layout.scalePixels(newBound.width) - container.width / 2;
                                if (Layout.scalePixels(fullBound.width) <= group.x + group.width || group.x <= 0) {
                                    group.visible = false;
                                    group.alpha = 0;
                                } else {
                                    group.visible = true;
                                    group.alpha = 1;
                                }
                                break;
                            case "left_out":  // h_left_out
                                newBound = this.getFractionBound(0, 0)
                                group.x = Layout.scalePixels(newBound.width) ;
                                if (Layout.scalePixels(fullBound.width) < group.x + group.width ) {
                                    group.visible = false;
                                    group.alpha = 0;
                                } else {
                                    group.visible = true;
                                    group.alpha = 1;
                                }
                                break;
                            case "left_limit":  // h_left_limit
                            case "left":  // h_left
                                newBound = this.getFractionBound(0, 0)
                                group.x = Layout.scalePixels(newBound.width) ;
                                break;
                            case "right":  // h_right
                                newBound = this.getFractionBound(100, 0)
                                group.x = Layout.scalePixels(newBound.width) - container.width  ;
                                break;
                            case "right_limit":  // h_right_limit
                                newBound = this.getFractionBound(100, 0)
                                const newX = Layout.scalePixels(newBound.width) - container.width   ;
                                group.x = newX > 0 ? newX : 0;
                                break;
                            case "right_out":  // h_right_out
                                newBound = this.getFractionBound(0, 100)
                                const newX1 = Layout.scalePixels(newBound.width) - container.width ;
                                if (newX1 < 0) {
                                    group.visible = false;
                                    group.alpha = 0;
                                } else {
                                    group.visible = true;
                                    group.alpha = 1;
                                    group.x = newX1;
                                }
                            default:
                                break;
                        }
                    }



                    // TODO: UGLY HACK - figure out why these change and how to preserve them
                    // TODO: probably should be put back in the config after the positioning it can be retrieve
                    group["originalBounds"] = {
                        x: group.x,
                        y: group.y,
                        width: group.width,
                        height: group.height,
                    };
                }
            }
        }

        // this.restartParticles();

        if(this._rescaleChangeCallback) {
            this._rescaleChangeCallback()
        }
    }


    protected rescaleObject(obj: any, bounds: IObjectConfig, lock = true) {

        if (Layout.isLandscape()) {

            Layout.testSetWidth(obj, bounds.width, lock );
            if (Layout.getHeight(obj) > bounds.height) {
                Layout.testSetHeight(obj, bounds.height );
            }
        } else {
            Layout.testSetHeight(obj, bounds.height, lock );
            if (Layout.getWidth(obj) > bounds.width) {
                Layout.testSetWidth(obj, bounds.width );
            }
        }
    }

    protected parseScaledBoundConfig(bounds: IObjectConfig): IObjectConfig {
        if (!bounds) {
            return;
        }

        // const canvasWidth = parseInt(App.instance.view.style.width.match(/[0-9]*/)[0]);
        // const canvasHeight = parseInt(App.instance.view.style.height.match(/[0-9]*/)[0]);
        // const canvasWidth = App.instance.view.width/App.instance.renderer.resolution;
        // const canvasHeight = App.instance.view.height/App.instance.renderer.resolution;
        const canvasWidth = Layout.canvasWidth;
        const canvasHeight = Layout.canvasHeight;
        // const canvasWidth = App.instance.stage.width;
        // const canvasHeight = App.instance.stage.height;
        const gameRect = this.orientation === ViewOrientation.Portrait ? Layout.fullPortraitRect : Layout.fullRect;
        const refreceRect = { width: canvasWidth , height: canvasHeight  };
        const bound = {
            id: bounds.id,
            x: Layout.getX({ x: Layout.relWidth(Math.round(Layout.percentWidth(bounds.x, gameRect)), refreceRect) }),
            y: Layout.getY({ y: Layout.relHeight(Layout.percentHeight(bounds.y, gameRect), refreceRect) }),
            width: Layout.getWidth({ width: Layout.relWidth(Layout.percentWidth(bounds.width, gameRect), refreceRect) }),
            height: Layout.getHeight({ height: Layout.relHeight(Layout.percentHeight(bounds.height, gameRect), refreceRect) })
        }

        return bound;
    }


    protected getFractionBound(w: number, h: number): {width: number, height: number}  {
            // const canvasWidth = App.instance.view.width / App.instance.renderer.resolution;
            // const canvasHeight = App.instance.view.height / App.instance.renderer.resolution;
            const canvasWidth = Layout.canvasWidth;
            const canvasHeight = Layout.canvasHeight;
            const refrenceRect = {width: canvasWidth , height: canvasHeight };

            const bound = {
                width: Layout.getWidth( {width: Layout.relWidth(w, refrenceRect)}),
                height: Layout.getHeight({height: Layout.relHeight(h, refrenceRect)})
            }

            return bound;

    }

    protected calculateTextMultiplier():number {
        return Layout.isLandscape() ? 1 : Layout.portraitMultiplier;
    }

    protected changeOrientation(newOrientation: ViewOrientation) {
        // App.instance.ticker.stop()
        if (this._preOrientationChangeCallback) {
            this._preOrientationChangeCallback()
        }
        super.changeOrientation(newOrientation);
        this.reposition();
        // App.instance.ticker.start()/
        if (this._orientationChangeCallback) {
            this._orientationChangeCallback()
        }
    }
}
